<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="设备变动记录"
      edit-title
      id-key="ChangeRecordsId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="over"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="单据日期">
              <el-date-picker
                v-model="data.RecordDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="单据编码" prop="RecordNo">
              <el-input v-model="data.RecordNo" placeholder="请输入单据编码" />
            </el-form-item> -->
            <el-form-item label="单据编码" prop="RecordNo">
              <span v-if="Mode == 0" class="detail-span">{{
                data.RecordNo
              }}</span>
              <el-input
                v-else
                v-model="data.RecordNo"
                placeholder="请输入类别编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="变动方式" prop="ChangeType">
              <el-select v-model="data.ChangeType">
                <el-option value="累计工作量" label="累计工作量"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px">
          <span>设备列表</span>
          <div style="float: right">
            <el-button type="primary" @click="add">添加</el-button>
            <!-- <el-button type="danger" @click="delRow">删除</el-button> -->
          </div>
        </div>
        <el-table
          ref="table"
          class="table-line tb-c-head"
          @selection-change="handleSelectionChange"
          :data="facList"
          border
        >
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column label="设备编码" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.EquipmentNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备名称" min-width="110" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.EquipmentName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" min-width="110" align="center">
            <template slot-scope="{ row, $index }">
              <el-input
                type="number"
                v-model="row.Quantity"
                @input="updateChange($event, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="修改前累计工作量"
            min-width="110"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.BeforeChange }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改后累计工作量"
            min-width="110"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.AfterChange }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="110" align="center">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click.native="del(row, $index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </common-dialog>
    <facility-dialog
      ref="facilityDialog"
      in-dialog
      selectable
      @select="setFac"
    ></facility-dialog>
    <manage-select
      ref="manageSelect"
      in-dialog
      selectable
      multiple
      @select-multiple="setManage"
    ></manage-select>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import facilityDialog from "@/components/facility/manage/listDialog";
import manageSelect from "@/components/facility/manage/listDialog.vue";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    facilityDialog,
    manageSelect,
  },
  data() {
    return {
      data: {
        ChangeRecordsId: 0,
        RecordNo: "",
        RecordDate: this.$commonJs.getToday(),
        ChangeType: "累计工作量",
        DetailDtos: [],
      },
      timmer: null,
      index: null,
      beforeChange: [],
      Mode: 1,
      facList: [],
      code_api: require("@/api/sy/serialCode").default,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/changeRecords").default,
      showList: [],
      rules: {
        JobName: [{ required: true, message: "请输入岗位名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    onCreateOpened() {
      this.code_api.previewNo("设备变动单").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.RecordNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取设备变动单编码失败");
        }
      });
    },
    onEditOpened(data) {
      this.api.info(data.ChangeRecordsId).then((res) => {
        this.data = res.Data;
        this.facList = res.Data.DetailDtos.map((i) => ((i.T = 3), i));
        this.beforeChange = res.Data.DetailDtos.map((i) => ({
          id: i.EquipmentId,
          AfterChange: i.AfterChange,
        }));
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    openFacility(data) {
      this.index = data;
      this.$refs.facilityDialog.open().then((that) => that.getData());
    },
    setFac(data) {
      console.log(data);
      this.facList[this.index].value2 = data.JobName;
      this.index = null;
    },
    add() {
      this.$refs.manageSelect.open().then((that) => that.getData());
    },
    setManage(data) {
      // console.log("data", data);
      const Ids = this.facList.map((i) => i.EquipmentId) ?? [];
      const addList = data.reduce((acc, item) => {
        if (!Ids.includes(item.EquipmentId)) acc.push({ T: 0, ...item });
        return acc;
      }, []);
      this.facList = [...this.facList, ...addList];
    },
    del(data, index) {
      this.facList.splice(index, 1);
    },
    onBeforeSave() {
      if (this.data.DetailDtos.length == 0) {
        this.data.DetailDtos = this.facList.map((item) => ((item.T = 0), item));
      } else {
        
        let delIds = this.facList.map((item) => item.ChangeRecordsDetailId);
        let delList = this.data.DetailDtos.reduce((arr, item) => {
          if (!delIds.includes(item.ChangeRecordsDetailId)) arr.push({ ...item, T: 2 });
          return arr;
        }, []);

        let addIds = this.data.DetailDtos.map((item) => item.ChangeRecordsDetailId);
        let addList = [];
        addList = this.facList.reduce((arr, item) => {
          if (!addIds.includes(item.ChangeRecordsDetailId)) arr.push({ ...item, T: 0 });
          return arr;
        }, []);

        let updateList = this.facList.filter((item) => item.T === 1);
        this.data.DetailDtos = [...addList, ...delList, ...updateList];
      }
    },
    delRow() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let delList = this.multipleSelection.map((item) => item.DistrictId);
          let data = this.areaList.filter(
            (item) => !delList.includes(item.DistrictId)
          );
          this.areaList = JSON.parse(JSON.stringify(data));
        })
        .catch(() => {});
    },
    updateChange(data, index) {
      clearInterval(this.timmer);
      this.timmer = setInterval(() => {
        if (this.facList[index].T === 3) this.facList[index].T = 1;
        let before = this.beforeChange.filter(
          (i) => i.id == this.facList[index].EquipmentId
        );
        if (before && before.length > 0)
          this.facList[index].BeforeChange = before[0].AfterChange;
        this.facList[index].AfterChange = this.facList[index].Quantity;
        clearInterval(this.timmer);
      }, 500);
    },
    over() {
      this.facList = [];
      this.showList = [];
      this.beforeChange = [];
      this.$refs.manageSelect.clear();
    },
  },
};
</script>
